import './VerticalScale.scss';

export type Coordinate = {
  proportion: number;
  value: number;
};

type VerticalScaleProps = {
  coordinates?: Coordinate[];
  valueFormatter?: (value: number) => string;
};

export const VerticalScale = ({
  coordinates = [],
  valueFormatter = (a) => `${a}`,
}: VerticalScaleProps) => (
  <div className="vertical-scale">
    {coordinates.map((coord) => (
      <div
        className="vertical-scale-value"
        style={{ bottom: `${coord.proportion * 100}%` }}
        key={`${coord.proportion}-${coord.value}`}
      >
        <div className="vertical-scale-value-label">
          {' '}
          {valueFormatter(coord.value)}{' '}
        </div>
        <div className="vertical-scale-value-line" />
      </div>
    ))}
  </div>
);
